const formatAmount = (amount) => {
    amount = Number(amount)
    const parts = amount.toFixed(2).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

const formatPhoneNumber = (number) => {
    const numberStr = number.toString();
    const formattedNumber = numberStr.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
    return formattedNumber;
}

const formatStringDate = (inputDate) => {
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const formattedDate = new Date(inputDate).toLocaleDateString(undefined, options);
    return formattedDate;
}

const workTypeFormatChange = (workType) => {

    switch (workType) {
        case 'from_iw_amc_package_renewal':
        case 'from_ssp_amc_package_renewal':
        case 'from_amc_amc_package_renewal':
        case 'from_ow_amc_package_renewal':
            return 'AMC Package renewal'

        case 'from_iw_ssp_package_renewal':
        case 'from_amc_ssp_package_renewal':
        case 'from_ssp_ssp_package_renewal':
        case 'from_ow_ssp_package_renewal':
        case 'from_oc_ssp_package_renewal':
            return 'SSP Package renewal'

        case 'from_iw_carbon_change_without_package':
        case 'from_amc_carbon_change_without_package':
        case 'from_ssp_carbon_change_without_package':
        case 'from_ow_carbon_change_without_package':
            return 'Carbon Change without package'

        case 'from_ssp_periodical_service':
        case 'from_ow_periodical_service':
        case 'from_iw_periodical_service':
        case 'from_amc_periodical_service':
            return 'Periodical service'

        case 'from_ssp_complaint':
        case 'from_ow_complaint':
        case 'from_iw_complaint':
        case 'from_amc_complaint':
            return 'Complaint'

        default:
            return workType;
    }
}

const numberInWord = (amount) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion']; // Extend as needed

    function convertThreeDigits(num) {
        const numStr = num.toString();
        const [a, b, c] = numStr.padStart(3, '0').split('').map(Number);

        let result = '';
        if (a > 0) {
            result += units[a] + ' Hundred ';
        }
        if (b === 1) {
            result += teens[c] + ' ';
        } else {
            result += tens[b] + ' ' + units[c] + ' ';
        }
        return result;
    }

    function convertToWords(amount) {
        if (amount === 0) {
            return 'Zero';
        }

        const amountStr = amount.toString();
        const chunks = [];

        for (let i = amountStr.length; i > 0; i -= 3) {
            chunks.push(amountStr.slice(Math.max(0, i - 3), i));
        }

        let words = '';
        for (let i = chunks.length - 1; i >= 0; i--) {
            const chunk = parseInt(chunks[i]);
            if (chunk === 0) continue;

            words += convertThreeDigits(chunk) + thousands[i] + ' ';
        }

        return words.trim();
    }

    return convertToWords(amount);
}

const YYYYMMDDFormat = (ISOdate, symbol = '-') => {
    if (!ISOdate) {
        return ''
    }
    symbol = symbol ? symbol : ''
    const year = new Date(ISOdate)?.getFullYear();
    const month = String(new Date(ISOdate).getMonth() + 1).padStart(2, '0');
    const day = String(new Date(ISOdate).getDate()).padStart(2, '0');

    return `${year}${symbol}${month}${symbol}${day}`;
}

const DDMMYYYYFormat = (ISOdate, symbol = '-') => {
    if (!ISOdate) {
        return ''
    }
    symbol = symbol ? symbol : ''
    const year = new Date(ISOdate)?.getFullYear();
    const month = String(new Date(ISOdate).getMonth() + 1).padStart(2, '0');
    const day = String(new Date(ISOdate).getDate()).padStart(2, '0');

    return `${day}${symbol}${month}${symbol}${year}`;
}

const MMDDYYYYFormat = (ISOdate, symbol = '-') => {
    if (!ISOdate) {
        return ''
    }
    symbol = symbol ? symbol : ''
    const year = new Date(ISOdate)?.getFullYear();
    const month = String(new Date(ISOdate).getMonth() + 1);
    const day = String(new Date(ISOdate).getDate());

    return `${month}${symbol}${day}${symbol}${year}`;
}

const toCityNameFormate = (cityName) => {
    if (!cityName) {
        return;
    }

    const formattedCity = cityName
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
        .trim();

    return formattedCity
}

const formateDateToDayText = (isoDate) => {
    const date = new Date(isoDate);
    const today = new Date();

    // Normalize dates to ignore time for comparison
    today.setHours(23, 59, 59, 999);
    date.setHours(23, 59, 59, 999)

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const nextSeventhDay = new Date(today);
    nextSeventhDay.setDate(today.getDate() + 6);



    const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);

    if (date.getTime() === today.getTime()) {
        return 'Today';
    } else if (date.getTime() === yesterday.getTime()) {
        return 'Yesterday';
    } else if (date.getTime() === tomorrow.getTime()) {
        return 'Tomorrow';
    } else if (date.getFullYear() === today.getFullYear() && date.getTime() > today.getTime() && date.getTime() <= nextSeventhDay.getTime()) {
        return `${dayOfWeek}`;
    } else if (date.getFullYear() === today.getFullYear()) {
        return `${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
    } else {
        return `In ${formattedDate}`;
    }
}

function convertIsoToAmPm(isoString) {
    // Parse the ISO string into a Date object
    const date = new Date(isoString);

    // Get hours, minutes, and seconds
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Format hours for AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Pad minutes and seconds with leading zeros if needed
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;


    // Combine parts
    return `${hours}:${minutesStr} ${ampm}`;
}

const convertToWhatsappDateFormate = (timestamp) => {
    if (timestamp === undefined || timestamp === null) {
        return '';
    }

    const date = new Date(timestamp * 1000);
    const dateFormate = formateDateToDayText(date);
    const timeFormate = convertIsoToAmPm(date);

    return `${timeFormate}, ${dateFormate}`;
}

export {
    formatAmount, formatPhoneNumber, formatStringDate, workTypeFormatChange, numberInWord, YYYYMMDDFormat, DDMMYYYYFormat,
    MMDDYYYYFormat, toCityNameFormate, convertToWhatsappDateFormate, formateDateToDayText, convertIsoToAmPm
}